export default "__VITE_ASSET__MZ8YvS6h__"